export function isDefinedAndNotNull(o) {
  if (o === null || o === undefined) {
    return false;
  }
  return true;
}
export function isEntryDefinedAndNotNull(entry) {
  const [, value] = entry;
  return isDefinedAndNotNull(value);
}